import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Carousel, Container, Image } from "react-bootstrap";

import * as telemedicineActions from "../../store/actions/index";
import Button from "../../components/UI/Button/Button";
import Modal from "../../components/UI/Modal/Modal";

import classes from "./Telemedicine.module.css";

import medical from "../../assets/images/icon-medical.svg";
import {Contact, WebsiteAlert} from "../../components/UI/Alerts/ContactAlert/ContactAlert";
import { usFormatPhoneNumber } from "../../utils";
import { withTranslation } from "react-i18next";

interface IParentProps {
  modalClosed: () => void;
}
interface IStateFromProps {
  details: {};
  t:any;
  // error: string;
  // errorMessage: string;
}

interface IDispatchFromProps {
  onFetchTelemedicineProviderDetails: (userId: string) => void;
}
type Props = IParentProps & IStateFromProps & IDispatchFromProps;
class Telemedicine extends Component<Props> {
  state = {
    connect: false,
    website: false,
    errorUserId: false,
  };
  componentDidMount() {
    console.log("Component did mount in telemedicine");
    const userId = localStorage.getItem("userId");
    console.log(localStorage.getItem("userId"));
    if (userId !== null) {
      this.props.onFetchTelemedicineProviderDetails(userId);
    } else {
      this.props.onFetchTelemedicineProviderDetails("");
      this.setState({ errorUserId: true });
    }
  }
  contactHandler = () => {
    this.setState({ connect: true });
  };
  connectedHandler = () => {
    this.setState({ connect: false });
  };
  webConnectedHandler = () => {
    this.setState({ website: false });
  };
  browseHandler = () => {
    if (
      this.props.details &&
      this.props.details["result"] &&
      this.props.details["result"].providerUrl
    ) {
      window.open(this.props.details["result"].providerUrl, "_blank");
    } else {
      this.setState({ website: true });
    }
  };

  render() {
    const {t} = this.props;
    const btnStyle = {
      margin: "5px",
    };
    const modalContact = {
      width: "360px",
      left: "calc(50% - 180px)",
    };
    // console.log(
    //   "errorMessage ",
    //   this.props.error + " " + this.props.errorMessage
    // );
    let connectAlert: any;
    if (this.state.connect) {
      connectAlert = (
        <Modal
          show={this.state.connect}
          childComp={
            <Contact
              modalClosed={this.connectedHandler}
              contactNumber={
                this.props.details &&
                this.props.details["result"] &&
                this.props.details["result"].providerContact
                  && usFormatPhoneNumber(
                      this.props.details["result"].providerContact
                    )
                  
              }
            />
          }
          style={modalContact}
        />
      );
    }
    let websiteAlert: any;
    if (this.state.website) {
      websiteAlert = (
        <Modal
          show={this.state.website}
          childComp={
            <WebsiteAlert
              modalClosed={this.webConnectedHandler}
              website="Website not available"
            />
          }
          style={modalContact}
        />
      );
    }
    
    return (
      <Fragment>
        {connectAlert}
        {websiteAlert}
        <Container fluid>
          <Carousel
            controls={false}
            interval={null}
            indicators={true}
            className={classes.carousel}
          >
            <Carousel.Item>
              <div className="carouselBanner carouselBannerImg">
                <h2 className="carouselTitle">{t('teleMedicine.aboutTelemedicine')}</h2>
                <Image src={medical} alt="medical" />
              </div>
              <div className={classes.bannerContent}>
                <p>
                 {t('teleMedicine.nonEmergency')}{" "}
                </p>
                <p>
                 {t('teleMedicine.careService')}
                </p>
                <p>
                  {" "}
                 {t('teleMedicine.lifeThreatening')}
                </p>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="carouselBanner">
                <h2 className="carouselTitle">{t('teleMedicine.virtualCare')}</h2>
              </div>
              <div className={classes.bannerContent}>
                <p>
                  <b>
                    {t('teleMedicine.commonConditions')}
                  </b>{" "}
                </p>
                <div className={classes.teliList}>
                  <ul>
                    <li>{t('teleMedicine.flu')}</li>
                    <li>{t('teleMedicine.allergies')}</li>
                    <li>{t('teleMedicine.urinary')}</li>
                  </ul>
                  <ul>
                    <li>{t('teleMedicine.sinus')}</li>
                    <li>{t('teleMedicine.pinkEye')}</li>
                    <li>{t('teleMedicine.andMore')}</li>
                  </ul>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="carouselBanner">
                <h2 className="carouselTitle">{t('teleMedicine.getStarted')}</h2>
              </div>
              <div className={classes.bannerContent}>
                <p>
                  <b>{t('teleMedicine.teleMedicineOption')}</b>
                </p>{" "}
                <p>
                  {" "}
                  {t('teleMedicine.activity')}
                </p>
              </div>
            </Carousel.Item>
          </Carousel>
          <div className={classes.teliBottom}>
            <h5>{t('teleMedicine.telemedicineProvider')}</h5>
            <h4 className={classes.teladoc}>
              {this.props.details &&
              this.props.details["result"] &&
              this.props.details["result"].providerName
                ? this.props.details["result"].providerName
                : ""}
            </h4>
            <Button
              label={t('teleMedicine.contact')}
              clicked={this.contactHandler}
              style={btnStyle}
              displayImg={true}
              image="icon-message-circle.svg"
              disabled={false}
            />
            <Button
              label={t('teleMedicine.website')}
              clicked={this.browseHandler}
              style={btnStyle}
              displayImg={true}
              image="browser.svg"
              disabled={false}
            />
          </div>
        </Container>
      </Fragment>
    );
  }
}
const mapStateToProps = (state: any) => ({
  details: state.telemedicine.details,
  // errorMessage: state.telemedicine.errorMessage,
  // error: state.telemedicine.error,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchTelemedicineProviderDetails: (userId) =>
    dispatch(telemedicineActions.fetchTelemedicineProviderDetails(userId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Telemedicine));
